var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SndType from 'audio/sfx/SndType.mp3';
import SndError from 'audio/sfx/SndWrong.mp3';
import SndBell from 'audio/sfx/SndCorrect.mp3';
import { createAudioAsync, createAudio, stopHowl } from 'utils/audio-util';
import { mapState, application, student } from '../store/helpers';
import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            playList: [],
            index: 0
        };
    },
    computed: Object.assign(Object.assign({}, mapState(student, ['accessibilitySettings'])), mapState(application, {
        isMobile: state => state.device.isMobile
    })),
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadCommonSounds();
        });
    },
    watch: {
        accessibilitySettings() {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.loadCommonSounds();
            });
        }
    },
    methods: {
        getVolume() {
            return this.accessibilitySettings.audioSettings.muteSounds
                ? 0
                : this.accessibilitySettings.audioSettings.volume * 0.01;
        },
        loadCommonSounds() {
            return __awaiter(this, void 0, void 0, function* () {
                const [howlType, howlError, howlBell] = yield Promise.all([
                    createAudioAsync(SndType, {
                        html5: !this.isMobile,
                        volume: this.getVolume()
                    }),
                    createAudioAsync(SndError, {
                        html5: !this.isMobile,
                        volume: this.getVolume()
                    }),
                    createAudioAsync(SndBell, {
                        html5: !this.isMobile,
                        volume: this.getVolume()
                    })
                ]);
                this.playList = [
                    {
                        src: SndType,
                        howl: howlType
                    },
                    {
                        src: SndError,
                        howl: howlError
                    },
                    {
                        src: SndBell,
                        howl: howlBell
                    }
                ];
            });
        },
        sndType() {
            return this.playCommon(0);
        },
        sndError() {
            return this.playCommon(1);
        },
        sndBell() {
            return this.playCommon(2);
        },
        sndBellAndAfterPlayOtherHowl(otherHowl) {
            const sndBellHowl = this.sndBell();
            if (!sndBellHowl)
                return;
            const playStepAudio = () => {
                sndBellHowl.off('end', playStepAudio);
                sndBellHowl.off('stop', playStepAudio);
                otherHowl.play();
            };
            sndBellHowl.on('end', playStepAudio);
            sndBellHowl.on('stop', playStepAudio);
        },
        playCommon(indexToPlay) {
            const previousSound = this.playList[this.index];
            if (previousSound)
                stopHowl(previousSound);
            const index = indexToPlay;
            const data = this.playList[index];
            if (!data)
                return;
            if (!data.howl) {
                // This is only needed for Firefox
                data.howl = createAudio(data.src, {
                    html5: !this.isMobile,
                    volume: this.getVolume()
                });
            }
            data.howl.play();
            this.index = index;
            return data.howl;
        }
    }
});
